export default "__VITE_ASSET__760WDeSA__"